import axiosConfig from "./axiosConfig";

const API_URL = "/v1/secretaires";

const secretairesService = {
  // Get all secretaires
  getAll: async () => {
    try {
      const response = await axiosConfig.get(API_URL);
      return response.data;
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.message ||
          "Erreur lors de la récupération des secrétaires",
        data: null,
        error: err,
      };
    }
  },

  // Create a new secretaire
  create: async (data) => {
    try {
      const response = await axiosConfig.post(API_URL, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.message ||
          "Erreur lors de la création de la secrétaire",
        data: err.response?.data,
        error: err,
      };
    }
  },

  // Update secretaire (PUT or PATCH, choose based on your backend)
  update: async (id, data) => {
    try {
      const response = await axiosConfig.put(`${API_URL}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.message ||
          "Erreur lors de la mise à jour de la secrétaire",
        data: err.response?.data,
        error: err,
      };
    }
  },

  // Delete secretaire
  delete: async (id) => {
    try {
      const response = await axiosConfig.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.message ||
          "Erreur lors de la suppression de la secrétaire",
        data: err.response?.data,
        error: err,
      };
    }
  },
};

export default secretairesService;
